import { useState, useEffect } from "react";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Rajdhani:wght@400;500;600;700&family=Orbitron:wght@400;600;700;900&display=swap');

  .contact-section {
    position: relative;
    z-index: 1;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 100px 4rem 80px;
    font-family: 'Rajdhani', sans-serif;
  }

  .contact-container {
    width: 100%;
    max-width: 1100px;
    margin: 0 auto;
  }

  .contact-header {
    text-align: center;
    margin-bottom: 4rem;
  }

  .contact-label {
    font-family: 'Orbitron', monospace;
    font-size: 0.65rem;
    font-weight: 600;
    color: #ff8c00;
    letter-spacing: 5px;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    margin-bottom: 1rem;
    opacity: 0;
    animation: contactFadeUp 0.7s ease 0.1s both;
  }
  .contact-label::before, .contact-label::after { content: ''; width: 50px; height: 1px; }
  .contact-label::before { background: linear-gradient(to right, transparent, #ff8c00); }
  .contact-label::after  { background: linear-gradient(to left,  transparent, #ff8c00); }

  .contact-title {
    font-family: 'Orbitron', monospace;
    font-size: clamp(1.8rem, 4vw, 2.8rem);
    font-weight: 900;
    background: linear-gradient(135deg, #ffffff 0%, #38c8ff 60%, #00aaff 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    filter: drop-shadow(0 0 20px rgba(0,170,255,0.3));
    opacity: 0;
    animation: contactFadeUp 0.7s ease 0.2s both;
    margin-bottom: 0.8rem;
  }

  .contact-subtitle {
    font-size: 1rem;
    color: rgba(232,244,255,0.45);
    opacity: 0;
    animation: contactFadeUp 0.7s ease 0.3s both;
  }

  .contact-layout {
    display: grid;
    grid-template-columns: 1fr 1.2fr;
    gap: 2rem;
    opacity: 0;
    animation: contactFadeUp 0.7s ease 0.4s both;
  }

  .contact-info-card {
    background: rgba(0, 20, 50, 0.5);
    border: 1px solid rgba(0,170,255,0.12);
    border-top: 2px solid #ff8c00;
    padding: 2rem;
    position: relative;
  }

  .contact-info-card::before {
    content: '';
    position: absolute;
    top: -2px; left: 0; right: 0;
    height: 2px;
    background: linear-gradient(to right, #ff8c00, transparent);
  }

  .contact-info-eyebrow {
    font-family: 'Orbitron', monospace;
    font-size: 0.6rem;
    color: #ffaa33;
    letter-spacing: 3px;
    text-transform: uppercase;
    margin-bottom: 1.5rem;
    display: flex;
    align-items: center;
    gap: 0.6rem;
  }

  .contact-info-eyebrow::before {
    content: '';
    display: inline-block;
    width: 20px;
    height: 1px;
    background: #ffaa33;
  }

  .contact-item {
    display: flex;
    align-items: flex-start;
    gap: 1rem;
    margin-bottom: 1.5rem;
    padding-bottom: 1.5rem;
    border-bottom: 1px solid rgba(0,170,255,0.08);
  }

  .contact-item:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }

  .contact-item-icon {
    width: 42px;
    height: 42px;
    background: rgba(0,170,255,0.08);
    border: 1px solid rgba(0,170,255,0.22);
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
    flex-shrink: 0;
  }

  .contact-item-label {
    font-family: 'Orbitron', monospace;
    font-size: 0.6rem;
    color: #00aaff;
    letter-spacing: 2px;
    text-transform: uppercase;
    margin-bottom: 0.3rem;
  }

  .contact-item-value {
    font-size: 0.92rem;
    color: rgba(232,244,255,0.75);
    font-weight: 600;
    word-break: break-all;
  }

  .contact-item-value a {
    color: rgba(232,244,255,0.75);
    text-decoration: none;
    transition: color 0.3s;
  }

  .contact-item-value a:hover { color: #00aaff; }

  .contact-item-value2 {
    font-size: 0.88rem;
    color: rgba(232,244,255,0.45);
    margin-top: 0.15rem;
    word-break: break-all;
  }

  .contact-item-value2 a {
    color: rgba(232,244,255,0.45);
    text-decoration: none;
    transition: color 0.3s;
  }

  .contact-item-value2 a:hover { color: #00aaff; }

  .contact-right {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  .contact-social-card {
    background: rgba(0, 20, 50, 0.5);
    border: 1px solid rgba(0,170,255,0.12);
    border-top: 2px solid #00aaff;
    padding: 1.8rem;
    position: relative;
  }

  .contact-social-card::before {
    content: '';
    position: absolute;
    top: -2px; left: 0; right: 0;
    height: 2px;
    background: linear-gradient(to right, #00aaff, transparent);
  }

  .social-eyebrow {
    font-family: 'Orbitron', monospace;
    font-size: 0.6rem;
    color: #00aaff;
    letter-spacing: 3px;
    text-transform: uppercase;
    margin-bottom: 1.2rem;
    display: flex;
    align-items: center;
    gap: 0.6rem;
  }

  .social-eyebrow::before {
    content: '';
    display: inline-block;
    width: 20px;
    height: 1px;
    background: #00aaff;
  }

  .social-links { display: flex; flex-direction: column; gap: 0.8rem; }

  .social-link {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 0.9rem 1.2rem;
    background: rgba(0,170,255,0.04);
    border: 1px solid rgba(0,170,255,0.12);
    text-decoration: none;
    transition: all 0.3s;
    clip-path: polygon(8px 0%, 100% 0%, calc(100% - 8px) 100%, 0% 100%);
  }

  .social-link:hover {
    background: rgba(0,170,255,0.1);
    border-color: rgba(0,170,255,0.4);
    transform: translateX(4px);
  }

  .social-link-icon { font-size: 1.2rem; flex-shrink: 0; }

  .social-link-info { flex: 1; }

  .social-link-name {
    font-family: 'Orbitron', monospace;
    font-size: 0.7rem;
    font-weight: 700;
    color: #00aaff;
    letter-spacing: 1px;
  }

  .social-link-url {
    font-size: 0.8rem;
    color: rgba(232,244,255,0.4);
    margin-top: 0.1rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .social-link-arrow { font-size: 0.8rem; color: rgba(0,170,255,0.4); }

  .contact-form-card {
    background: rgba(0, 20, 50, 0.5);
    border: 1px solid rgba(0,170,255,0.12);
    border-top: 2px solid #00aaff;
    padding: 1.8rem;
    position: relative;
  }

  .contact-form-card::before {
    content: '';
    position: absolute;
    top: -2px; left: 0; right: 0;
    height: 2px;
    background: linear-gradient(to right, #00aaff, transparent);
  }

  .form-eyebrow {
    font-family: 'Orbitron', monospace;
    font-size: 0.6rem;
    color: #00aaff;
    letter-spacing: 3px;
    text-transform: uppercase;
    margin-bottom: 1.2rem;
    display: flex;
    align-items: center;
    gap: 0.6rem;
  }

  .form-eyebrow::before {
    content: '';
    display: inline-block;
    width: 20px;
    height: 1px;
    background: #00aaff;
  }

  .form-group { margin-bottom: 1rem; }

  .form-label {
    font-family: 'Orbitron', monospace;
    font-size: 0.58rem;
    color: #4a7a9b;
    letter-spacing: 2px;
    text-transform: uppercase;
    display: block;
    margin-bottom: 0.4rem;
  }

  .form-input, .form-textarea {
    width: 100%;
    background: rgba(0,170,255,0.04);
    border: 1px solid rgba(0,170,255,0.15);
    color: #e8f4ff;
    font-family: 'Rajdhani', sans-serif;
    font-size: 0.95rem;
    padding: 0.7rem 1rem;
    outline: none;
    transition: border-color 0.3s, box-shadow 0.3s;
    box-sizing: border-box;
  }

  .form-input:focus, .form-textarea:focus {
    border-color: rgba(0,170,255,0.5);
    box-shadow: 0 0 12px rgba(0,170,255,0.1);
  }

  .form-textarea { resize: vertical; min-height: 100px; }

  .form-submit {
    width: 100%;
    padding: 0.85rem 2rem;
    background: linear-gradient(135deg, #00aaff, #0055bb);
    color: #fff;
    font-family: 'Orbitron', monospace;
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 2px;
    text-transform: uppercase;
    border: none;
    cursor: pointer;
    clip-path: polygon(10px 0%, 100% 0%, calc(100% - 10px) 100%, 0% 100%);
    box-shadow: 0 0 20px rgba(0,170,255,0.3);
    transition: box-shadow 0.3s, transform 0.2s, opacity 0.3s;
    margin-top: 0.5rem;
  }

  .form-submit:hover:not(:disabled) {
    box-shadow: 0 0 35px rgba(0,170,255,0.6);
    transform: translateY(-2px);
  }

  .form-submit:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  /* SUCCESS / ERROR MESSAGE */
  .form-status {
    margin-top: 1rem;
    padding: 0.8rem 1rem;
    font-family: 'Orbitron', monospace;
    font-size: 0.65rem;
    letter-spacing: 1px;
    text-align: center;
    border-radius: 2px;
  }

  .form-status.success {
    background: rgba(0,255,100,0.08);
    border: 1px solid rgba(0,255,100,0.3);
    color: #00ff64;
  }

  .form-status.error {
    background: rgba(255,50,50,0.08);
    border: 1px solid rgba(255,50,50,0.3);
    color: #ff5555;
  }

  .contact-footer-note {
    text-align: center;
    margin-top: 3rem;
    padding-top: 2rem;
    border-top: 1px solid rgba(0,170,255,0.08);
    opacity: 0;
    animation: contactFadeUp 0.7s ease 0.6s both;
  }

  .contact-footer-text {
    font-family: 'Orbitron', monospace;
    font-size: 0.65rem;
    color: #4a7a9b;
    letter-spacing: 2px;
  }

  .contact-footer-name { color: #00aaff; }

  @keyframes contactFadeUp {
    from { opacity: 0; transform: translateY(24px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  @media (max-width: 900px) {
    .contact-section { padding: 100px 2rem 60px; }
    .contact-layout { grid-template-columns: 1fr; }
  }
`;

const SOCIAL_LINKS = [
  {
    icon: "💻",
    name: "GitHub",
    url: "https://github.com/s2023101986-Vinvin",
    display: "github.com/s2023101986-Vinvin",
  },
  {
    icon: "💼",
    name: "LinkedIn",
    url: "https://www.linkedin.com/in/vincent-del-mundo-manalo-7b14523a8",
    display: "linkedin.com/in/vincent-del-mundo-manalo",
  },
  {
    icon: "📘",
    name: "Facebook",
    url: "https://www.facebook.com/Manalo.vincent4",
    display: "facebook.com/Manalo.vincent4",
  },
];

const SERVICE_ID  = "service_x6h67so";
const TEMPLATE_ID = "template_mm2svul";
const PUBLIC_KEY  = "d3XaaPB14BV4aK2yt";

export default function Contact() {
  const [formData, setFormData] = useState({ from_name: "", from_email: "", message: "" });
  const [status, setStatus] = useState(null); // null | 'sending' | 'success' | 'error'

  useEffect(() => {
    // Load EmailJS SDK
    if (!window.emailjs) {
      const script = document.createElement("script");
      script.src = "https://cdn.jsdelivr.net/npm/@emailjs/browser@3/dist/email.min.js";
      script.onload = () => window.emailjs.init(PUBLIC_KEY);
      document.head.appendChild(script);
    } else {
      window.emailjs.init(PUBLIC_KEY);
    }
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (!formData.from_name || !formData.from_email || !formData.message) {
      setStatus("empty");
      return;
    }

    setStatus("sending");

    try {
      await window.emailjs.send(SERVICE_ID, TEMPLATE_ID, {
        from_name:  formData.from_name,
        from_email: formData.from_email,
        message:    formData.message,
      });
      setStatus("success");
      setFormData({ from_name: "", from_email: "", message: "" });
    } catch (err) {
      setStatus("error");
    }
  };

  return (
    <section className="contact-section" id="contact">
      <style>{styles}</style>
      <div className="contact-container">

        <div className="contact-header">
          <p className="contact-label">Get In Touch</p>
          <h2 className="contact-title">Contact</h2>
          <p className="contact-subtitle">
            Feel free to reach out for collaborations, opportunities, or just to say hi!
          </p>
        </div>

        <div className="contact-layout">

          {/* LEFT */}
          <div className="contact-info-card">
            <p className="contact-info-eyebrow">Contact Details</p>

            <div className="contact-item">
              <div className="contact-item-icon">📧</div>
              <div>
                <p className="contact-item-label">Email</p>
                <p className="contact-item-value">
                  <a href="mailto:delmundomanalov@gmail.com">delmundomanalov@gmail.com</a>
                </p>
                <p className="contact-item-value2">
                  <a href="mailto:s2023101986@firstasia.edu.ph">s2023101986@firstasia.edu.ph</a>
                </p>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-item-icon">📱</div>
              <div>
                <p className="contact-item-label">Phone</p>
                <p className="contact-item-value">
                  <a href="tel:+639515610718">+63 951 561 0718</a>
                </p>
                <p className="contact-item-value2">
                  <a href="tel:+639954914297">+63 995 491 4297</a>
                </p>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-item-icon">📍</div>
              <div>
                <p className="contact-item-label">Location</p>
                <p className="contact-item-value">Bulihan, Malvar, Batangas, Philippines</p>
                <p className="contact-item-value2">Open to remote opportunities</p>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-item-icon">🟢</div>
              <div>
                <p className="contact-item-label">Status</p>
                <p className="contact-item-value">Available for Opportunities</p>
                <p className="contact-item-value2">Internship · Part-time · Freelance</p>
              </div>
            </div>
          </div>

          {/* RIGHT */}
          <div className="contact-right">

            <div className="contact-social-card">
              <p className="social-eyebrow">Social Links</p>
              <div className="social-links">
                {SOCIAL_LINKS.map((s, i) => (
                  <a key={i} href={s.url} target="_blank" rel="noreferrer" className="social-link">
                    <span className="social-link-icon">{s.icon}</span>
                    <div className="social-link-info">
                      <p className="social-link-name">{s.name}</p>
                      <p className="social-link-url">{s.display}</p>
                    </div>
                    <span className="social-link-arrow">→</span>
                  </a>
                ))}
              </div>
            </div>

            <div className="contact-form-card">
              <p className="form-eyebrow">Send a Message</p>

              <div className="form-group">
                <label className="form-label">Your Name</label>
                <input
                  className="form-input"
                  type="text"
                  name="from_name"
                  placeholder="John Doe"
                  value={formData.from_name}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label className="form-label">Your Email</label>
                <input
                  className="form-input"
                  type="email"
                  name="from_email"
                  placeholder="john@email.com"
                  value={formData.from_email}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label className="form-label">Message</label>
                <textarea
                  className="form-textarea"
                  name="message"
                  placeholder="Hi Vincent, I'd like to connect..."
                  value={formData.message}
                  onChange={handleChange}
                />
              </div>

              <button
                className="form-submit"
                onClick={handleSubmit}
                disabled={status === "sending"}
              >
                {status === "sending" ? "⏳ Sending..." : "⚡ Send Message"}
              </button>

              {status === "success" && (
                <div className="form-status success">
                  ✅ Message sent! I'll get back to you soon.
                </div>
              )}
              {status === "error" && (
                <div className="form-status error">
                  ❌ Failed to send. Please try again.
                </div>
              )}
              {status === "empty" && (
                <div className="form-status error">
                  ⚠️ Please fill in all fields.
                </div>
              )}
            </div>

          </div>
        </div>

        <div className="contact-footer-note">
          <p className="contact-footer-text">
            © 2025 <span className="contact-footer-name">Vincent D. Manalo</span> · BS Computer Engineering · FAITH Colleges
          </p>
        </div>

      </div>
    </section>
  );
}